<template>
   <div class="rating-input">
        <input class="rating-input__input" v-model="rating">
        <div class="rating-input__stars">
            <span
                class="rating-input__star"
                v-for="(star, index) in maxRating"
                :key="index" @click="setRating(index + 1)"
                :class="{'rating-input__star--active': index + 1 <= rating}"
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.9999 4.03265L14.486 9.10891C14.5584 9.25688 14.6991 9.35965 14.8621 9.38366L20.4316 10.204L16.3998 14.1612C16.2829 14.2758 16.2296 14.4405 16.2571 14.6019L17.2077 20.1866L12.2341 17.5512C12.0877 17.4736 11.9123 17.4736 11.7659 17.5512L6.79233 20.1866L7.74291 14.6019C7.77038 14.4405 7.71709 14.2758 7.60023 14.1612L3.56838 10.204L9.13687 9.38366C9.29985 9.35965 9.44054 9.2569 9.51301 9.10897L11.9999 4.03265Z" />
                </svg>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'rating-input',
    data() {
        return {
            rating: null,
        };
    },
    props: {
        maxRating: {
            type: Number,
            default: 5,
        },
    },
    methods: {
        setRating(value) {
            if (+this.rating === value) {
                this.rating = null;
            } else {
                this.rating = value;
            }
        },
    },
    watch: {
        rating() {
            this.$emit('input', this.rating);
        },
    },
};
</script>
